<template>
  <div id="OutStockPlanDetail" style="margin: 0px auto">
    <div class="breadcrumb-box">
      <span class="back-btn" @click="goBack">《</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>采购管理</el-breadcrumb-item>
        <el-breadcrumb-item>出库管理</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
        <el-breadcrumb-item>{{ plan.planId }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="shop-content" style="background-color: white; padding: 20px 20px 0px 20px">
      <el-button class="opreate-btn" type="primary" size="small" @click="addBox">新增箱子</el-button>
      <el-button class="opreate-btn" type="primary" size="small" @click="addSKU">新增SKU</el-button>
      <el-button class="opreate-btn" type="primary" size="small" @click="addRedundantSKU">新增冗余SKU</el-button>
      <el-button class="opreate-btn" v-print="'#subOutputRank-print'" type="primary" size="small" @click="printOutStock">打印出库单</el-button>
      <el-button class="opreate-btn" type="primary" size="small"><download-excel :data="asinStockData" :fields="exportTitles" :name="getExportName()">导出商品</download-excel></el-button>
      <el-button class="opreate-btn" type="primary" size="small"><download-excel :data="redundantAsinStockData" :fields="exportRedundantSKUTitles" :name="getExportName()">导出可冗余SKU</download-excel></el-button>
    </div>
    <div class="plan-conent" id="subOutputRank-print">
      <div class="shop-content">
        <div class="title-content">
          <span class="title-label">出口计划编号：</span>
          <span class="title-text">{{ plan.planId }}</span>
          <span class="title-label" style="margin-left: 20px">头程物流：</span>
          <span class="title-text">{{ getLogisticsTypeLabel(plan.logisticsType) }}</span>
          <span class="title-label" style="margin-left: 20px">店铺名称：</span>
          <span class="title-text">{{ plan.shopName }}</span>
          <span class="title-label" style="margin-left: 20px">出库日期：</span>
          <span class="title-text">{{ plan.date }}</span>
        </div>
      </div>

      <div v-if="plan.planVersion == 2">
        <div class="plan-group" v-for="group in groups">
          <div class="group-opreate">
            <span class="title-label">箱子分组编号：{{ group.groupId }}</span>
            <el-button v-if="selectRows.length > 0" class="opreate-btn" type="primary" size="small" @click="configBox" style="margin-left: 20px">分配箱子</el-button>
            <el-button v-if="selectRows.length > 0" class="opreate-btn" type="primary" size="small" @click="configPlan" style="margin-left: 20px">分配出库计划</el-button>
          </div>
          <el-table :data="group.asinStockList" :ref="'fixBoxTable' + group.groupId" stripe size="mini" :highlight-current-row="true" @selection-change="handleSelectionChange" v-longpress.prevent="handleLongPress" @cell-mouse-enter="handleMouseEnter" show-summary>
            <el-table-column type="selection" width="40" align="center"></el-table-column>
            <!-- <el-table-column prop="shopName" label="店铺" width="50px" align="left" :key="109"> </el-table-column> -->
            <el-table-column prop="productName" label="产品名称" width="90px" :key="11"> </el-table-column>
            <el-table-column prop="productColorName" label="颜色" width="70px" :key="12" sortable> </el-table-column>
            <el-table-column prop="sku" label="SKU" width="220px" :key="13" sortable>
              <template slot-scope="scope">
                <span @click="copySku(scope.row.sku)">{{ scope.row.sku }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="model" label="机型" width="70px" :key="14" sortable> </el-table-column>
            <el-table-column prop="totalOutStockCount" label="合计出库数量" width="50px" align="right" :key="15" sortable> </el-table-column>
            <el-table-column prop="box1OutStockCount" label="箱子1数量" width="50px" align="right" :key="16" sortable> </el-table-column>
            <el-table-column prop="box2OutStockCount" label="箱子2数量" width="50px" align="right" :key="117" sortable> </el-table-column>
            <el-table-column prop="box3OutStockCount" label="箱子3数量" width="50px" align="right" :key="18" sortable> </el-table-column>
            <el-table-column prop="box4OutStockCount" label="箱子4数量" width="50px" align="right" :key="19" sortable> </el-table-column>
            <el-table-column prop="box5OutStockCount" label="箱子5数量" width="50px" align="right" :key="20" sortable> </el-table-column>
            <el-table-column prop="localInventory" label="本地库存数量" width="50px" align="right" :key="21" sortable> </el-table-column>
            <el-table-column prop="fnsku" label="FNSKU" width="90px" :key="22" align="center"> </el-table-column>
            <el-table-column label="操作" width="150px" :key="223" align="center">
              <template slot-scope="scope">
                <!-- <el-button class="opreate-btn" type="text" size="small" @click="splitAsinStock(scope.row)">拆分</el-button> -->
                <!-- <el-button v-if="isMergeSku(scope.row.sku)" class="opreate-btn" type="text" size="small" @click="mergeAsinStock(scope.row)">合并</el-button> -->
                <el-button class="opreate-btn" type="text" size="small" @click="deleteAsinStock(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-else>
        <div class="box-content">
          <div class="title-content">
            <span class="title-label">箱子编号：</span>
            <span class="title-text">未分配</span>
            <el-button v-if="selectRows.length > 0" class="opreate-btn" type="primary" size="small" @click="configBox" style="margin-left: 20px">分配箱子</el-button>
            <el-button v-if="selectRows.length > 0" class="opreate-btn" type="primary" size="small" @click="configPlan" style="margin-left: 20px">分配出库计划</el-button>
          </div>
          <el-table ref="noBoxTable" boxId="-1" :data="plan.noBoxAsinStockList" stripe size="mini" :highlight-current-row="true" @selection-change="handleSelectionChange" v-longpress.prevent="handleLongPress" @cell-mouse-enter="handleMouseEnter" show-summary>
            <el-table-column type="selection" width="40" align="center"></el-table-column>
            <!-- <el-table-column prop="shopName" label="店铺" width="50px" align="left" :key="109"> </el-table-column> -->
            <el-table-column prop="productName" label="产品名称" width="90px" :key="11"> </el-table-column>
            <el-table-column prop="productColorName" label="颜色" width="70px" :key="13" sortable> </el-table-column>
            <el-table-column prop="sku" label="SKU" width="220px" :key="10" sortable>
              <template slot-scope="scope">
                <span @click="copySku(scope.row.sku)">{{ scope.row.sku }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="model" label="机型" width="70px" :key="12" sortable> </el-table-column>
            <el-table-column prop="outStockCount" label="出库数量" width="50px" align="right" :key="16" sortable> </el-table-column>
            <el-table-column prop="localInventory" label="本地库存数量" width="50px" align="right" :key="19" sortable> </el-table-column>
            <el-table-column prop="fnsku" label="FNSKU" width="90px" :key="20" align="center"> </el-table-column>
            <el-table-column label="操作" width="150px" :key="17" align="center">
              <template slot-scope="scope">
                <el-button class="opreate-btn" type="text" size="small" @click="splitAsinStock(scope.row)">拆分</el-button>
                <el-button v-if="isMergeSku(scope.row.sku)" class="opreate-btn" type="text" size="small" @click="mergeAsinStock(scope.row)">合并</el-button>
                <el-button class="opreate-btn" type="text" size="small" @click="deleteAsinStock(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <template v-for="box in plan.boxs">
          <div class="box-content">
            <div class="title-content">
              <span class="title-label">箱子类型：</span>
              <span class="title-text">{{ box.boxType == "groupBox" ? "5箱箱子组" : "普通箱子" }}</span>
              <span class="title-label" style="margin-left: 20px">箱子编号：</span>
              <span class="title-text">{{ box.boxId }}</span>
              <span class="title-label" style="margin-left: 20px">箱子规格：</span>
              <span class="title-text">{{ box.length + "*" + box.width + "*" + box.height }}</span>
              <span class="title-label" style="margin-left: 20px">泡重：</span>
              <span class="title-text">{{ box.bubbleWeight }} KG</span>
              <span class="title-label" style="margin-left: 20px">称重：</span>
              <span class="title-text">{{ box.lyWeight > 0 ? box.lyWeight : "--" }} KG</span>
              <el-button v-if="plan.status == 1" class="opreate-btn" type="text" size="small" @click="editBoxWeight(box)" style="margin-left: 5px">编辑</el-button>
              <el-button v-if="box.asinStockList.length == 0" class="opreate-btn" type="text" size="small" @click="deleteBox(box.boxId)" style="margin-left: 20px">删除箱子</el-button>
              <el-button v-if="selectRows.length > 0" class="opreate-btn" type="primary" size="small" @click="configBox" style="margin-left: 20px">分配箱子</el-button>
              <el-button v-if="selectRows.length > 0" class="opreate-btn" type="primary" size="small" @click="configPlan" style="margin-left: 20px">分配出库计划</el-button>
            </div>

            <el-table :ref="'boxTable' + box.boxId" :boxId="box.boxId" :data="box.asinStockList" stripe size="mini" :highlight-current-row="true" @selection-change="handleSelectionChange" v-longpress.prevent="handleLongPress" @cell-mouse-enter="handleMouseEnter" show-summary>
              <el-table-column type="selection" width="40" align="center"></el-table-column>
              <!-- <el-table-column prop="shopName" label="店铺" width="50px" align="left" :key="109"> </el-table-column> -->
              <el-table-column prop="productName" label="产品名称" width="90px" :key="11"> </el-table-column>
              <el-table-column prop="productColorName" label="颜色" width="70px" :key="13"> </el-table-column>
              <el-table-column prop="sku" label="SKU" width="220px" :key="10">
                <template slot-scope="scope">
                  <span @click="copySku(scope.row.sku)">{{ scope.row.sku }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="model" label="机型" width="70px" :key="12"> </el-table-column>

              <template v-if="box.boxType == 'groupBox'">
                <el-table-column prop="outStockCount" label="出库数量" width="50px" align="right" :key="115" sortable>
                  <template slot-scope="scope">
                    <span :class="(scope.row.outStockCount + ~~scope.row.fictitiousQuantity) % 5 != 0 ? 'redBg' : ''" style="padding: 5px 2px 5px 20px; display: inline-block">{{ scope.row.outStockCount }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="每箱数量" width="50px" align="right" :key="116" sortable>
                  <template slot-scope="scope">
                    <span>{{ Math.round(scope.row.outStockCount / 5) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="虚增数量" width="50px" align="right" :key="1116" sortable>
                  <template slot-scope="scope">
                    <span>{{ scope.row.fictitiousQuantity > 0 ? scope.row.fictitiousQuantity : "-" }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="box2OutStockCount" label="箱子2数量" width="50px" align="right" :key="117" sortable> </el-table-column>
                <el-table-column prop="box3OutStockCount" label="箱子3数量" width="50px" align="right" :key="118" sortable> </el-table-column>
                <el-table-column prop="box4OutStockCount" label="箱子4数量" width="50px" align="right" :key="119" sortable> </el-table-column>
                <el-table-column prop="box5OutStockCount" label="箱子5数量" width="50px" align="right" :key="120" sortable> </el-table-column> -->
              </template>
              <template v-else>
                <el-table-column prop="outStockCount" label="出库数量" width="50px" align="right" :key="16"> </el-table-column>
              </template>
              <el-table-column prop="localInventory" label="本地库存数量" width="50px" align="right" :key="19" sortable> </el-table-column>
              <el-table-column prop="fnsku" label="FNSKU" width="90px" :key="20" align="center"></el-table-column>
              <el-table-column label="操作" width="150px" :key="17" align="center">
                <template slot-scope="scope">
                  <el-button class="opreate-btn" type="text" size="small" @click="splitAsinStock(scope.row)">拆分</el-button>
                  <el-button v-if="isMergeSku(scope.row.sku)" class="opreate-btn" type="text" size="small" @click="mergeAsinStock(scope.row)">合并</el-button>
                  <el-button v-if="(scope.row.outStockCount + ~~scope.row.fictitiousQuantity) % 5 != 0" class="opreate-btn" type="text" size="small" @click="fictitiousQuantityAsinStock(scope.row)">虚增</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </div>
    </div>

    <el-dialog title="拆分" :visible.sync="splitDialogFormVisible" width="20%">
      <div class="form-line">
        <span class="form-label">合计数量：</span>
        <span class="form-text">{{ this.splitParams.leftCount }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">剩余数量：</span>
        <span class="form-text">{{ this.splitParams.leftCount - this.splitParams.splitCount }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">拆分数量：</span>
        <el-input class="form-input" placeholder="请输入" v-model="splitParams.splitCount" size="small" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="splitDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="splitHandleConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="合并" :visible.sync="mergeDialogFormVisible" width="540px">
      <el-table ref="table" class="merge-table" :data="mergeAsinStockList" stripe size="mini" :highlight-current-row="true" @selection-change="handleSelectionChange" @current-change="handleCurrentChange">
        <el-table-column label="选择" width="60px" align="center" :key="100">
          <template slot-scope="scope"> <el-radio v-model="mergeParams.mergeToAsinStockId" :label="scope.row.asinStockId"></el-radio></template>
        </el-table-column>
        <el-table-column prop="boxId" label="箱子编号" width="120px" :key="101">
          <template slot-scope="scope">
            {{ scope.row.boxId == -1 ? "未分配" : scope.row.boxId }}
          </template>
        </el-table-column>
        <el-table-column prop="sku" label="SKU" width="200px" :key="102"> </el-table-column>
        <el-table-column prop="outStockCount" label="出库数量" width="120px" align="right" :key="103"> </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="mergeDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="mergeHandleConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="分配箱子" :visible.sync="confgBoxDialogFormVisible" width="540px">
      <el-radio v-model="configParams.toBoxId" :label="-1">未分配</el-radio>
      <template v-for="box in plan.boxs">
        <el-radio v-model="configParams.toBoxId" :label="box.boxId">{{ box.boxId }}</el-radio>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confgBoxDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="configBoxHandleConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="分配计划" :visible.sync="confgPlanDialogFormVisible" width="750px">
      <el-table ref="table" class="merge-table" :data="outStockPlans" stripe size="mini" :highlight-current-row="true" @current-change="handlePlanCurrentChange">
        <el-table-column label="选择" width="60px" align="center" :key="100">
          <template slot-scope="scope"> <el-radio v-model="configPlanParams.toPlanId" :label="scope.row.planId"></el-radio></template>
        </el-table-column>
        <el-table-column prop="date" label="日期" width="80px" align="center" :key="109"> </el-table-column>
        <el-table-column prop="shopName" label="店铺" width="60px" align="center" :key="111"> </el-table-column>
        <el-table-column prop="planId" label="出库计划编号" width="100px" align="center" :key="110"> </el-table-column>
        <el-table-column label="箱子数量" width="60px" align="right" :key="112">
          <template slot-scope="scope">
            {{ scope.row.boxs.length }}
          </template>
        </el-table-column>
        <el-table-column label="SKU数量" width="80px" align="right" :key="115">
          <template slot-scope="scope">
            {{ getOutStockSKUCount(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="商品数量" width="80px" align="right" :key="115">
          <template slot-scope="scope">
            {{ getOutStockCount(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80px" align="center" :key="113">
          <template slot-scope="scope">
            {{ getStatusLabel(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="头程物流" width="100px" align="center" :key="114">
          <template slot-scope="scope">
            {{ getLogisticsTypeLabel(scope.row.logisticsType) }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confgPlanDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="configPlanHandleConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增SKU" :visible.sync="dialogAddSKUVisible" width="600px">
      <div class="form-line">
        <span class="form-label">SKU</span>
        <el-input class="form-input" placeholder="请输入" v-model="addSKUParams.sku" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">出库数量</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="addSKUParams.outStockCount" size="small" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogAddSKUVisible = false">取消</el-button>
        <el-button class="opreate-btn" type="primary" size="small" @click="handleAddSKUClick">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增箱子" :visible.sync="dialogAddBoxVisible" width="400px">
      <div class="form-line">
        <span class="form-label">箱子类型</span>
        <el-radio-group v-model="addBoxType">
          <el-radio label="groupBox">5箱箱子组</el-radio>
          <el-radio label="normalBbox">普通箱子</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label">箱子规格</span>
        <el-select class="box-select" placeholder="请选择" size="small" v-model="addBoxId" style="width: 200px">
          <el-option label="请选择" value=""></el-option>
          <el-option v-for="box in outStockBoxs" :label="getBoxLabel(box)" :value="box.boxId"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <span class="form-label">箱子数量</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="addBoxCount" size="small"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogAddBoxVisible = false">取消</el-button>
        <el-button class="opreate-btn" type="primary" size="small" @click="handleAddBoxClick">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增冗余SKU" :visible.sync="dialogAddRedundantVisible" width="840px">
      <el-table ref="redundantTable" :data="redundantAsinStockList" stripe size="mini" :highlight-current-row="true" show-summary>
        <!-- <el-table-column type="selection" width="40" align="center"></el-table-column> -->
        <el-table-column prop="level" label="权重等级" width="50px" align="center"></el-table-column>
        <el-table-column prop="productName" label="产品名称" width="100px"> </el-table-column>
        <el-table-column prop="productColorName" label="颜色" width="90px"> </el-table-column>
        <el-table-column prop="sku" label="SKU" width="230px">
          <template slot-scope="scope">
            <span @click="copySku(scope.row['seller-sku'])">{{ scope.row["seller-sku"] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="机型" width="80px"> </el-table-column>
        <el-table-column prop="maxRedundantOutStockCount" label="可冗余数量" width="50px" align="right"> </el-table-column>
        <el-table-column label="冗余数量" width="50px" align="right">
          <template slot-scope="scope">
            <span @click="onRedundantCountClick(scope.row)" style="cursor: pointer; color: red">{{ scope.row.redundantOutStockCount > 0 ? scope.row.redundantOutStockCount : "" }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="localInventory" label="本地库存" width="50px" align="right"> </el-table-column> -->
        <!-- <el-table-column prop="fnsku" label="FNSKU" width="110px" align="center"></el-table-column> -->
        <el-table-column label="操作" width="150px" :key="17" align="center">
          <template slot-scope="scope">
            <el-button class="opreate-btn" type="text" size="small" @click="addToOutStockPlan(scope.row)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogAddRedundantVisible = false">取消</el-button>
        <el-button class="opreate-btn" type="primary" size="small" @click="handleAddRedundantSKUClick">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";

export default {
  data() {
    return {
      splitDialogFormVisible: false,
      mergeDialogFormVisible: false,
      confgBoxDialogFormVisible: false,
      dialogAddSKUVisible: false,
      confgPlanDialogFormVisible: false,
      dialogAddBoxVisible: false,
      dialogAddRedundantVisible: false,
      redundantAsinStockList: [],
      purchasePlansForOutStock: [],
      addBoxType: "groupBox",
      addBoxId: "",
      addBoxCount: 1,
      planList: [],
      params: {
        planId: this.$route.query.planId,
      },
      screenHeight: document.body.clientHeight - 64 - 132 - 68,
      multipleSelection: [],
      activeName: "",
      plan: { noBoxAsinStockList: [], boxs: [] },
      splitParams: {
        planId: this.$route.query.planId,
        asinStockId: "",
        leftCount: 0,
        splitCount: 0,
      },
      mergeParams: {
        planId: this.$route.query.planId,
        mergeFromAsinStockId: "",
        mergeToAsinStockId: "",
      },
      configParams: {
        planId: this.$route.query.planId,
        toBoxId: "",
        asinStockIdList: [],
      },
      addSKUParams: {
        planId: this.$route.query.planId,
        sku: "",
        outStockCount: 0,
      },
      configPlanParams: {
        fromPlanId: this.$route.query.planId,
        toPlanId: "",
        asinStockIdList: [],
      },
      mergeAsinStockList: [],
      isSelectModel: false,
      selectRows: [],
      selectBoxId: -1,
      outStockPlans: [],
      outStockBoxs: [],
    };
  },
  mounted() {
    this.getData();
    this.fetchOutStockBoxs();

    this.fetchPurchasePlansForOutStock();

    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    goBack() {
      window.history.back();
    },
    addRedundantSKU() {
      this.dialogAddRedundantVisible = true;

      this.fetchPurchasePlansForOutStock();
    },
    fetchOutStockBoxs() {
      requestModules.fetchOutStockBoxs({ status: 1 }).then(res => {
        this.outStockBoxs = res.ldata;
      });
    },
    getBoxLabel(box) {
      return `${box.length}*${box.width}*${box.height} _ (${box.bubbleWeight}KG)`;
    },
    fetchPurchasePlansForOutStock() {
      // 用于冗余产品
      requestModules.fetchPurchasePlansForOutStock({ shopType: this.plan.shopType, boxType: 5, funType: "outStock" }).then(res => {
        this.purchasePlansForOutStock = res.ldata;

        this.purchasePlansForOutStock.forEach(item => {
          item.maxRedundantOutStockCount = item["maxRedundantOutStockCountFor5Box"];
          item.redundantOutStockCount = 0;
        });

        this.redundantAsinStockList = this.getRedundantOutStockList();
      });
    },
    getRedundantOutStockList() {
      let list = [];
      this.purchasePlansForOutStock.forEach(item => list.push({ ...item, sku: item["seller-sku"] }));
      let sortFun = function (a, b) {
        if (!a.productName || !a.productColor || !a.model || !b.productName || !b.productColor || !b.model) {
          return 0;
        }

        if (a.level !== b.level) {
          return b.level - a.level;
        } else if (a.shopType !== b.shopType) {
          return a.shopType - b.shopType;
        } else if (a.productName !== b.productName) {
          return a.productName.localeCompare(b.productName);
        } else if (a.productColor !== b.productColor) {
          return a.productColor.localeCompare(b.productColor);
        } else if (a.model !== b.model) {
          return a.model.localeCompare(b.model);
        } else {
          return 0;
        }
      };
      list.sort(sortFun);
      return list;
    },
    onRedundantCountClick(row) {
      this.$prompt("请输入冗余数量", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // inputPattern: /^\d+$/,
        inputErrorMessage: "请输入正确的数量",
        inputValue: row["redundantOutStockCount"],
      })
        .then(({ value }) => {
          let maxRedundantOutStockCount = row.maxRedundantOutStockCount;
          if (value > maxRedundantOutStockCount + row.redundantOutStockCount || value < 0) {
            this.$message({
              type: "error",
              message: "请输入正确的数量",
            });
            return;
          }

          let totalCount = row.redundantOutStockCount + maxRedundantOutStockCount;
          let newOutStockCount = totalCount - value;
          if (newOutStockCount % 5 != 0) {
            this.$message({
              type: "error",
              message: "请输入正确的数量",
            });
            return;
          }

          row.maxRedundantOutStockCount = totalCount - parseInt(value);
          row.redundantOutStockCount = parseInt(value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    addToOutStockPlan(row) {
      if (row.redundantOutStockCount > 0) {
        row.redundantOutStockCount = row.redundantOutStockCount + row.maxRedundantOutStockCount;
        row.maxRedundantOutStockCount = 0;
      } else {
        row.redundantOutStockCount = row.maxRedundantOutStockCount;
        row.maxRedundantOutStockCount = 0;
      }
    },
    addRedundantToOutStockPlan() {
      this.dialogAddRedundantVisible = false;
    },

    handleAddRedundantSKUClick() {
      this.dialogAddRedundantVisible = false;
      let redundantList = [];
      this.redundantAsinStockList.forEach(
        asinStock =>
          asinStock.redundantOutStockCount > 0 &&
          redundantList.push({
            sku: asinStock.sku,
            fnsku: asinStock.fnsku,
            redundantOutStockCount: asinStock.redundantOutStockCount,
          })
      );

      requestModules.outAsinStockAddRedundantSKUs({ planId: this.params.planId, redundantList: JSON.stringify(redundantList) }).then(res => {
        this.$message({
          type: "success",
          message: "添加完成",
        });
        this.getData();
      });
    },
    fictitiousQuantityAsinStock(row) {
      this.$prompt("请输入虚增数量", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^-?\d+$/,
        inputErrorMessage: "请输入正确的数量",
        inputValue: row.fictitiousQuantity,
      })
        .then(({ value }) => {
          let params = {
            planId: this.params.planId,
            asinStockId: row.asinStockId,
            fictitiousQuantity: value,
          };
          requestModules.outAsinStockEditFictitiousQuantity(params).then(res => {
            this.$message({
              type: "success",
              message: "修改完成",
            });
            this.getData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    editBoxWeight(box) {
      if (this.plan.status != 1) {
        this.$message.error("仅出库中状态可编辑称重");
        return;
      }
      this.$prompt("请输入称重", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d+(\.\d+)?$/,
        inputErrorMessage: "请输入正确的称重",
        inputValue: box.lyWeight > 0 ? box.lyWeight : "",
      })
        .then(({ value }) => {
          requestModules
            .outStockPlanEditBoxWeight({
              planId: this.params.planId,
              boxId: box.boxId,
              lyWeight: value,
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "修改完成",
              });
              this.getData();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    getOutStockPlanData() {
      requestModules
        .fetchOutStockPlans({
          shopType: this.plan.shopType,
          status: 1,
        })
        .then(res => {
          this.outStockPlans = res.ldata;

          for (let i = 0; i < this.outStockPlans.length; i++) {
            let plan = this.outStockPlans[i];
            if (plan.planId == this.plan.planId) {
              this.outStockPlans.splice(i, 1);
              break;
            }
          }
        });
    },
    copySku(sku) {
      navigator.clipboard
        .writeText(sku)
        .then(() => {
          this.$message.success("已复制SKU");
        })
        .catch(error => {
          this.$message.error("复制SKU失败");
        });
    },
    printOutStock() {},
    configBox() {
      this.confgBoxDialogFormVisible = true;
    },
    configPlan() {
      this.confgPlanDialogFormVisible = true;
    },
    handleLongPress(event) {
      this.isSelectModel = event.type == "mousedown";

      this.selectBoxId = event.srcElement.closest(".el-table").getAttribute("boxId");

      this.selectRows.push(this.clickRow);

      // console.log(this.$refs["boxTable" + this.selectBoxId]);
      // console.log(this.$refs.noBoxTable);

      this.selectBoxId == "-1" && this.$refs.noBoxTable.toggleRowSelection(this.clickRow, true);
      this.selectBoxId != "-1" && this.$refs["boxTable" + this.selectBoxId][0].toggleRowSelection(this.clickRow, true);
    },
    handleMouseEnter(row, column, cell, event) {
      this.clickRow = row;
      if (!this.isSelectModel) {
        return;
      }
      this.selectRows.push(row);

      this.selectBoxId == "-1" && this.$refs.noBoxTable.toggleRowSelection(row, true);
      this.selectBoxId != "-1" && this.$refs["boxTable" + this.selectBoxId][0].toggleRowSelection(row, true);
      // this.plan.boxs.forEach(box => this.$refs["boxTable" + box.boxId].toggleRowSelection(row));
    },
    handleCurrentChange(val) {
      this.mergeParams.mergeToAsinStockId = val.asinStockId;
      console.log("mergeToAsinStockId", this.mergeParams.mergeToAsinStockId);
    },
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 132 - 68;
    },
    handleSelectionChange(val) {
      this.selectRows = val;
      let selectedAsinStockIdList = [];
      this.selectRows.forEach(row => selectedAsinStockIdList.push(row.asinStockId));
      this.configParams.asinStockIdList = JSON.stringify(selectedAsinStockIdList);

      this.configPlanParams.asinStockIdList = JSON.stringify(selectedAsinStockIdList);
    },
    configBoxHandleConfirm() {
      this.confgBoxDialogFormVisible = false;
      requestModules.outAsinStockBoxConfig(this.configParams).then(res => {
        this.$message.success("分配箱子完成！");
        this.getData();
      });
    },
    handlePlanCurrentChange(val) {
      this.configPlanParams.toPlanId = val.planId;
    },
    configPlanHandleConfirm() {
      this.confgPlanDialogFormVisible = false;
      requestModules.outAsinStockPlanConfig(this.configPlanParams).then(res => {
        this.$message.success("分配出库计划完成！");
        this.getData();
      });
    },
    splitAsinStock(row) {
      this.splitDialogFormVisible = true;
      this.splitParams.asinStockId = row.asinStockId;
      this.splitParams.leftCount = row.outStockCount;
      this.splitParams.splitCount = 0;
    },
    deleteAsinStock(row) {
      this.$confirm("是否确认删除SKU？", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.outAsinStockDeleteSKU({ planId: this.params.planId, asinStockId: row.asinStockId }).then(res => {
          this.getData();
        });
      });
    },
    fiveBoxOutStockPlanAddSKU(row) {
      this.$confirm("是否确认删除SKU？", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.fiveBoxOutStockPlanAddSKU({ planId: this.params.planId, asinStockId: row.asinStockId }).then(res => {
          this.getData();
        });
      });
    },
    fiveBoxOutStockPlanDeleteSKU(row) {
      this.$confirm("是否确认删除SKU？", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.fiveBoxOutStockPlanDeleteSKU({ planId: this.plan.shopType, asinStockId: row.asinStockId }).then(res => {
          this.getData();
        });
      });
    },
    splitHandleConfirm() {
      this.splitParams.leftCount = this.splitParams.leftCount - this.splitParams.splitCount;
      if (this.splitParams.leftCount <= 0 || this.splitParams.splitCount <= 0) {
        this.$message.error("拆分数量不对，请重新拆分！");
        return;
      }

      this.splitDialogFormVisible = false;
      requestModules.outAsinStockSplit(this.splitParams).then(res => {
        this.$message.success("拆分完成！");
        this.getData();
      });
    },
    mergeAsinStock(row) {
      this.mergeDialogFormVisible = true;
      this.mergeParams.mergeFromAsinStockId = row.asinStockId;
      this.mergeAsinStockList = [];
      this.plan.noBoxAsinStockList.forEach(
        asinStock =>
          asinStock.asin == row.asin &&
          (asinStock.asinStockId != row.asinStockId || asinStock.logisticsType != row.logisticsType) &&
          this.mergeAsinStockList.push({
            ...asinStock,
            boxId: -1,
          })
      );
      this.plan.boxs.forEach(box => {
        box.asinStockList.forEach(asinStock => asinStock.asin == row.asin && asinStock.asinStockId != row.asinStockId && this.mergeAsinStockList.push({ ...asinStock, boxId: box.boxId }));
      });
    },
    mergeHandleConfirm() {
      this.mergeDialogFormVisible = false;
      requestModules.outAsinStockMerge(this.mergeParams).then(res => {
        this.getData();
      });
    },
    addBox() {
      this.dialogAddBoxVisible = true;
      this.addBoxType = "groupBox";
      this.addBoxCount = 1;
    },
    handleAddBoxClick() {
      if (this.addBoxId == "") {
        this.$message.error("请选择箱子规格");
        return;
      }
      let boxCount = parseInt(this.addBoxCount, 10);
      if (!/^\d+$/.test(String(this.addBoxCount).trim()) || boxCount < 1) {
        this.$message.error("箱子数量需为大于等于1的整数");
        return;
      }
      let box = this.outStockBoxs.find(box => box.boxId == this.addBoxId);
      if (!box) {
        this.$message.error("请选择箱子规格");
        return;
      }
      this.dialogAddBoxVisible = false;
      let params = {
        ...box,
        planId: this.params.planId,
        boxType: this.addBoxType,
        boxCount,
      };
      delete params._id;

      requestModules.outStockPlanAddBox(params).then(res => {
        this.getData();
      });
    },
    addSKU() {
      this.dialogAddSKUVisible = true;
    },
    handleAddSKUClick() {
      this.$confirm("是否确认新增SKU", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        this.dialogAddSKUVisible = false;
        requestModules
          .outAsinStockAddSKU(this.addSKUParams)
          .then(res => {
            this.getData();
          })
          .catch(err => {
            this.$message.error(err.message);
          });
      });
    },
    deleteBox(boxId) {
      this.$confirm("是否确认删除箱子", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.outStockPlanDeleteBox({ planId: this.params.planId, boxId }).then(res => {
          this.getData();
        });
      });
    },
    printPlan() {},
    queryBtn() {
      this.getData();
    },
    importBtn() {
      this.dialogFormVisible = true;
    },
    getData() {
      console.log("getData");
      requestModules.fetchOutStockPlan(this.params).then(res => {
        this.plan = res.mdata;

        this.getOutStockPlanData();

        this.fetchPurchasePlansForOutStock();
      });
    },
    isMergeSku(sku) {
      let list = this.asinStockData.filter(asinStock => asinStock.sku == sku);
      return list.length >= 2;
    },
    getExportName() {
      return "出库计划_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    getLogisticsTypeLabel(logisticsType) {
      let label = "";
      logisticsType == 1 && (label = "红单快递");
      logisticsType == 2 && (label = "美森正班");
      logisticsType == 3 && (label = "海派海卡");
      return label;
    },
    getStatusLabel(row) {
      let label = "";
      row.status == 2 && (label = "出库完成");
      row.status == -1 && (label = "已作废");
      row.status == 1 && (label = "出库中");
      return label;
    },
    getOutStockCount(row) {
      let noBoxAsinStockList = row.noBoxAsinStockList;
      let boxs = row.boxs;
      let outStockCount = 0;
      noBoxAsinStockList.forEach(asinStock => (outStockCount += asinStock.outStockCount));
      boxs.forEach(box => box.asinStockList.forEach(asinStock => (outStockCount += asinStock.outStockCount)));
      return outStockCount;
    },
    getOutStockSKUCount(row) {
      let noBoxAsinStockList = row.noBoxAsinStockList;
      let boxs = row.boxs;
      let skuCount = 0;
      skuCount += noBoxAsinStockList.length;
      boxs.forEach(box => (skuCount += box.asinStockList.length));
      return skuCount;
    },
  },
  computed: {
    exportTitles() {
      let fields = {
        店铺: "shopName",
        SKU: "sku",
        FNSKU: "fusku",
        出库数量: "totalOutStockCount",
        实际数量: "outStockCount",
        虚增数量: "fictitiousQuantity",
        名称: "productName",
        机型: "model",
        颜色: "productColorName",
        箱子编号: "boxId",
      };
      return fields;
    },
    asinStockData() {
      let asinStockList = [...this.plan.noBoxAsinStockList];
      let boxs = this.plan.boxs;
      asinStockList.forEach(asinStock => {
        asinStock.boxId = "未分配";
        asinStock.totalOutStockCount = ~~asinStock.fictitiousQuantity + asinStock.outStockCount;
      });
      boxs.forEach(box => {
        box.asinStockList.forEach(asinStock => {
          asinStockList.push({
            ...asinStock,
            boxId: box.boxId,
            totalOutStockCount: ~~asinStock.fictitiousQuantity + asinStock.outStockCount,
          });
        });
      });

      return asinStockList;
    },
    exportRedundantSKUTitles() {
      let fields = {
        SKU: "sku",
        冗余数量: "maxRedundantOutStockCount",
        名称: "productName",
        机型: "model",
        颜色: "productColorName",
        FNSKU: "fnsku",
      };
      return fields;
    },
    redundantAsinStockData() {
      let asinStockList = [];
      this.redundantAsinStockList.forEach(asinStock => {
        asinStockList.push({
          sku: asinStock.sku,
          fnsku: asinStock.fnsku,
          maxRedundantOutStockCount: asinStock.maxRedundantOutStockCount,
          productName: asinStock.productName,
          model: asinStock.model,
          productColorName: asinStock.productColorName,
        });
      });

      return asinStockList;
    },
    groups() {
      let groups = [];
      if (this.plan.planVersion == 2) {
        let groupIdSet = new Set([]);
        this.plan.boxs.forEach(box => groupIdSet.add(box.groupId));
        let groupIds = [...groupIdSet];
        groupIds.forEach(groupId => {
          let box = this.plan.boxs.find(box => box.groupId == groupId);
          if (box) {
            let group = { asinStockList: [], groupId };
            let boxs = this.plan.boxs.filter(box => box.groupId == groupId);
            let skuSet = new Set([]);

            box.asinStockList.forEach(asinStock => skuSet.add(asinStock.sku));
            let skus = [...skuSet];

            for (let i = 0; i < skus.length; i++) {
              let sku = skus[i];
              let asinStock = null;
              for (let j = 0; j < boxs.length; j++) {
                let tempBox = boxs[j];
                let tempAsinStock = tempBox.asinStockList.find(asinStock => asinStock.sku == sku);
                if (!asinStock) {
                  asinStock = tempAsinStock;
                  asinStock.totalOutStockCount = tempAsinStock.outStockCount;
                } else {
                  asinStock.totalOutStockCount += tempAsinStock.outStockCount;
                }
                asinStock["box" + (j + 1) + "OutStockCount"] = tempAsinStock.outStockCount;
              }
              asinStock && group.asinStockList.push(asinStock);
            }
            groups.push(group);
          }
        });
      }
      return groups;
    },
  },
};
</script>

<style lang="scss">
#OutStockPlanDetail {
  .breadcrumb-box {
    .back-btn {
      vertical-align: middle;
      margin-right: 10px;
    }
    .el-breadcrumb {
      margin: 20px 0px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  input[aria-hidden="true"] {
    display: none !important;
  }

  .form-line {
    margin-bottom: 10px;
    .form-label {
      margin: 5px 10px 5px 0px;
      width: 80px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 200px;
      margin: 5px 0px;
      vertical-align: middle;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
    }
  }

  .plan-conent {
    padding: 20px;
    margin-bottom: 50px;
    background-color: white;

    .shop-content,
    .box-content,
    .plan-group {
      margin-bottom: 20px;
      .title-content,
      .group-box {
        display: inline-block;
        font-size: 14px;
        margin-right: 20px;
        height: 35px;
        line-height: 35px;

        .title-label {
          font-size: 14px;
          font-weight: bold;
        }
      }
      .opreate-btn {
      }
    }
    .box-content {
    }

    .merge-table .cell {
      .el-radio .el-radio__label {
        display: none;
      }
    }
    .el-table {
      margin-top: 20px;

      td {
        padding: 3px 0 !important;
      }

      .el-table__header col {
        padding-left: 2px;
        padding-right: 2px;
      }

      .el-table__header .cell {
        padding-left: 2px;
        padding-right: 2px;
        line-height: 14px;
      }
    }
    .el-table .cell {
      padding-left: 2px;
      padding-right: 2px;
      line-height: 14px;

      -webkit-user-select: none; /* Safari */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */

      .row-item {
        min-height: 14px;
      }

      .redBg {
        background-color: red;
        color: white;
      }
      .yellowBg {
        background-color: yellow;
      }
      .greenBg {
        background-color: green;
        color: white;
      }
      .redText {
        color: red;
      }
      .greenText {
        color: red;
      }
      .greenYellowText {
        color: rgb(233, 104, 104);
      }
      .yellowText {
        color: rgb(112, 56, 56);
      }
    }

    .el-table tr:hover {
      background-color: #f9f981;
    }

    .el-table tr:hover td {
      background-color: transparent;
    }

    .el-table .current-row {
      background-color: #f9f981;

      .el-table__cell {
        background-color: #f9f981;
      }
    }
  }
}
// .form-line {
//   margin: 5px 0;

//   .form-label {
//     margin-right: 20px;
//     display: inline-block;
//     text-align: left;
//   }
// }
</style>
